// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let PromotionEditDiscountedProductReducer_CouldNotRemoveProduct = /* @__PURE__ */Primitive_exceptions.create("PromotionEditDiscountedProductReducer.PromotionEditDiscountedProductReducer_CouldNotRemoveProduct");

let PromotionEditDiscountedProductReducer_CouldNotUpdateDiscount = /* @__PURE__ */Primitive_exceptions.create("PromotionEditDiscountedProductReducer.PromotionEditDiscountedProductReducer_CouldNotUpdateDiscount");

let PromotionEditDiscountedProductReducer_CouldReplicateDiscount = /* @__PURE__ */Primitive_exceptions.create("PromotionEditDiscountedProductReducer.PromotionEditDiscountedProductReducer_CouldReplicateDiscount");

function make(state, action) {
  switch (action.TAG) {
    case "Reset" :
      return action._0;
    case "ProductsAdded" :
      return Stdlib_Array.reduce(action._0, state, (acc, product) => {
        let oldProduct = state.find(current => current.cku === product.cku);
        if (oldProduct === undefined) {
          return Belt_Array.concatMany([
            [product],
            acc
          ]);
        }
        let updatedProduct_id = product.id;
        let updatedProduct_cku = product.cku;
        let updatedProduct_name = product.name;
        let updatedProduct_description = product.description;
        let updatedProduct_stockKeepingUnit = product.stockKeepingUnit;
        let updatedProduct_purchasePrice = product.purchasePrice;
        let updatedProduct_bulkUnit = product.bulkUnit;
        let updatedProduct_retailPrices = product.retailPrices;
        let updatedProduct_discount = oldProduct.discount;
        let updatedProduct = {
          id: updatedProduct_id,
          cku: updatedProduct_cku,
          name: updatedProduct_name,
          description: updatedProduct_description,
          stockKeepingUnit: updatedProduct_stockKeepingUnit,
          purchasePrice: updatedProduct_purchasePrice,
          bulkUnit: updatedProduct_bulkUnit,
          retailPrices: updatedProduct_retailPrices,
          discount: updatedProduct_discount
        };
        return Belt_Array.concatMany([
          [updatedProduct],
          acc.filter(current => current.cku !== product.cku)
        ]);
      });
    case "ProductRemoved" :
      let productCku = action._0;
      if (state.some(current => current.cku === productCku)) {
        return state.filter(current => current.cku !== productCku);
      }
      throw {
        RE_EXN_ID: PromotionEditDiscountedProductReducer_CouldNotRemoveProduct,
        Error: new Error()
      };
    case "ProductDiscountUpdated" :
      let discountKind = action._2;
      let discountAmount = action._1;
      let productCku$1 = action._0;
      if (state.some(current => current.cku === productCku$1)) {
        return state.map(current => {
          if (current.cku === productCku$1) {
            return {
              id: current.id,
              cku: current.cku,
              name: current.name,
              description: current.description,
              stockKeepingUnit: current.stockKeepingUnit,
              purchasePrice: current.purchasePrice,
              bulkUnit: current.bulkUnit,
              retailPrices: current.retailPrices,
              discount: {
                id: current.discount.id,
                amount: discountAmount,
                kind: discountKind
              }
            };
          } else {
            return current;
          }
        });
      }
      throw {
        RE_EXN_ID: PromotionEditDiscountedProductReducer_CouldNotUpdateDiscount,
        Error: new Error()
      };
    case "ProductDiscountReplicated" :
      let productCku$2 = action._0;
      let match = state.find(current => current.cku === productCku$2);
      if (match !== undefined) {
        let match$1 = match.discount;
        let kind = match$1.kind;
        let amount = match$1.amount;
        return state.map(current => ({
          id: current.id,
          cku: current.cku,
          name: current.name,
          description: current.description,
          stockKeepingUnit: current.stockKeepingUnit,
          purchasePrice: current.purchasePrice,
          bulkUnit: current.bulkUnit,
          retailPrices: current.retailPrices,
          discount: {
            id: current.discount.id,
            amount: amount,
            kind: kind
          }
        }));
      }
      throw {
        RE_EXN_ID: PromotionEditDiscountedProductReducer_CouldReplicateDiscount,
        Error: new Error()
      };
  }
}

export {
  PromotionEditDiscountedProductReducer_CouldNotRemoveProduct,
  PromotionEditDiscountedProductReducer_CouldNotUpdateDiscount,
  PromotionEditDiscountedProductReducer_CouldReplicateDiscount,
  make,
}
/* No side effect */
